module.exports = __webpack_public_path__ + "static/media/sugar.29c04476.jpg";